module.exports = __webpack_public_path__ + "img/colaborador(2).39c74f73.png";